const TimeHelper = {
  nowInSeconds() {
    return Math.floor(Date.now() / 1000);
  },
};

export default TimeHelper;



// WEBPACK FOOTER //
// ./src/util/TimeHelper.js